





import { defineComponent, onMounted, reactive } from '@vue/composition-api';
import Vue from 'vue';
export default defineComponent({
	props: {
		/**
		 * If true, the sticky will appear always (not only on scroll).
		 */
		stickyFixed: {
			type: Boolean,
			default: false,
		},
		/**
		 * If true, the positions for the sticky will change to `bottom`, `top`, `top`
		 * for mobile, tablet and desktop viewport, respectively.
		 */
		landingpage: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const state = reactive({
			offset: 150,
			positions: undefined as undefined | object,
			fixed: false,
		});

		onMounted(() => {
			if (props.landingpage) {
				state.positions = {
					sm: 'bottom',
					md: 'top',
					lg: 'top',
				};
			}
			if (props.stickyFixed) {
				state.fixed = true;
				return;
			}

			const stage = document.querySelector('.olb-stage') as HTMLElement;
			// we need next tick here, otherwise `stage.offsetHeight` returns a wrong value!
			Vue.nextTick(() => {
				if (stage) {
					// check if the page is initially scrolled
					let clientRectY = stage.getBoundingClientRect().y;
					if (clientRectY < 0) {
						// subtract (in this case it's "window.scrollY + (-clientRectY)")
						// from scroll offset to get correct bounding client rect
						clientRectY = window.scrollY + clientRectY;
					}

					state.offset = stage.offsetHeight + clientRectY;
				}
			});
		});
		return {
			state,
		};
	},
});
